import axios from 'axios';
import { API_ENDPOINTS } from '../const/ApiEndpoints';

/**
 * @param {{
 *   scope: string,
 *   payload: Record<string, unknown>,
 *   enqueueSnackbar: (message: string, options: { variant: string }) => void,
 * }} options
 */
export const postBulkVerdict = ({ scope, payload, enqueueSnackbar }) =>
  axios
    .post(`${API_ENDPOINTS.BULK_VERDICT}${scope}/`, payload)
    .then((response) => {
      enqueueSnackbar(
        response?.data?.Msg ||
          response?.data?.message ||
          'Bulk verdict submitted successfully.',
        { variant: 'success' }
      );
      return response;
    })
    .catch((error) => {
      enqueueSnackbar(
        error?.response?.data?.Msg ||
          error?.response?.data?.message ||
          error?.message ||
          'Unable to submit bulk verdict.',
        { variant: 'error' }
      );
      throw error;
    });
